export default __webpack_public_path__ + "static/media/right-angle.dec6c941.svg";